import { ITextInputElement } from "@graffer-inc/form-schema";
import { TenantProcessResultInputElementValidator } from "./input-element-validator";

export const TenantProcessResultValidationConstant = {
  TOTAL_MAX_INPUT_ELEMENTS: 25,
} as const;

/**
 * 処理結果InputElementsの設定値を検証するクラス
 */
export class TenantProcessResultInputElementsValidator {
  constructor(readonly elements: ITextInputElement[]) {}

  validate() {
    const results: string[] = [];
    this.append(results, this.duplicateIds());
    this.append(results, this.totalInputCount());
    return results;
  }

  /**
   * 子要素を含めたバリデーション
   */
  validateDeep() {
    const results = this.validate();
    this.append(results, this.validateChildren());
    return results;
  }

  private validateChildren() {
    return this.elements.reduce<string[]>((preV, curV) => {
      const results = new TenantProcessResultInputElementValidator(
        curV,
      ).validate();
      return [...preV, ...results.map((v) => `[${curV.label.text}]: ${v}`)];
    }, []);
  }

  private duplicateIds() {
    const idSet = new Set();
    const duplicated = this.elements.find((e) => {
      if (idSet.has(e.id)) {
        return true;
      }
      idSet.add(e.id);
      return false;
    });
    return duplicated
      ? `重複しているID[${duplicated.id}]があります`
      : undefined;
  }

  private totalInputCount() {
    const totalInputCount = this.elements.length;
    if (
      totalInputCount >
      TenantProcessResultValidationConstant.TOTAL_MAX_INPUT_ELEMENTS
    ) {
      return `入力項目の合計数は${TenantProcessResultValidationConstant.TOTAL_MAX_INPUT_ELEMENTS}までです`;
    }
    if (totalInputCount === 0) {
      return "入力項目を1つ以上設定してください";
    }
    return undefined;
  }

  private append(error: string[], newError: string | string[] | undefined) {
    if (newError === undefined) {
      return;
    }
    if (typeof newError === "string") {
      error.push(newError);
      return;
    }
    if (newError.every((v) => typeof v === "string")) {
      error.push(...newError);
      return;
    }
    throw new Error(`type of ${typeof error} is invalid`);
  }
}
